import { action, computed, makeObservable, observable } from "mobx";
import type { IUploadSourcesStore } from "./UploadSourcesStore";
import type { SourceInfoModel } from "../../../../OpenApi/api";
import type { IUploadDialogStore } from "./UploadDialogStore";
import { fireAndForget } from "../../../util/async/fireAndForget";

export interface IUploadMenuStore {
	readonly showLink: boolean;
	readonly sourcesWithUploadPortalToShow: SourceInfoModel[];
	readonly ableToGenerateForSources: SourceInfoModel[];
	readonly uploadCodeDialogIsShown: boolean;
	showUploadCodeDialog(show: boolean): void;
}

export class UploadMenuStore implements IUploadMenuStore {
	@observable
	public uploadCodeDialogIsShown: boolean = false;

	constructor(
		private readonly uploadSourcesStore: IUploadSourcesStore,
		private readonly uploadDialogStore: IUploadDialogStore,
	) {
		makeObservable(this);
	}

	public get sourcesWithUploadPortalToShow(): SourceInfoModel[] {
		const { uploadSourcesStore } = this;
		const { sourcesWithUploadPortalToShow } = uploadSourcesStore;
		return sourcesWithUploadPortalToShow;
	}

	public get ableToGenerateForSources(): SourceInfoModel[] {
		const { uploadSourcesStore } = this;
		const { ableToGenerateForSources } = uploadSourcesStore;
		return ableToGenerateForSources;
	}

	@computed
	public get showLink(): boolean {
		return this.sourcesWithUploadPortalToShow.length > 0 || this.ableToGenerateForSources.length > 0;
	}

	@action
	public showUploadCodeDialog(show: boolean): void {
		const { uploadDialogStore } = this;
		if (show) {
			uploadDialogStore.reset();

			//Immediately generate when opening dialog when only 1 source is available
			if (this.ableToGenerateForSources.length === 1) {
				fireAndForget(uploadDialogStore.generateUploadCode());
			}
		}
		this.uploadCodeDialogIsShown = show;
	}
}
